module.exports = __webpack_public_path__ + "static/media/m_y_35.d3f68aa5.png";